module.exports = __webpack_public_path__ + "static/media/yt.c6758908.webp";